var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" 404 NOT FOUND ")]),_c('button',{on:{"click":_vm.goBackToMain}},[_vm._v("GO BACK")])])}
var staticRenderFns = []

export { render, staticRenderFns }